<template>
    <div class="container">
        <p class="contentBlack">重要提示</p>
        <p class="content">欢迎使用{{ name }}贵族服务，为了保障您的权益，请在您使用服务之前，详细阅读本《{{ name }}贵族服务协议》（以下简称“本协议”）所有内容，
            特别是加粗部分，确保您充分理解本协议各条款，包括但不限于免除平台责任的条款及限制用户权利的条款</p>
        <p class="content">除非您已阅读并接受本协议所有条款，否则请您不要确认（包括但不限于点击同意、进入购买程序、支付费用等）本服务。
            当您点击同意、购买或使用{{ name }}贵族服务时，即视为您已阅读并同意接受本协议的约束。</p>

        <p class="contentBlack">第一条 本协议的接受和修订</p>
        <p class="content">1.1 本协议内容包括协议正文、《用户协议》、《隐私协议》、{{ name }}平台（以下或称“本平台”）已经发布的或将来可能发布/更新的各类规则
            （以下合称“相关服务规则”）。相关服务规则均为本协议不可分割的组成部分，与协议正文具有同等法律效力，本协议正文与前述规则存在冲突的，
            以本协议正文为准。除另行明确声明外，您使用{{ name }}贵族服务均受本协议约束。</p>
        <p class="content">1.2 本协议及相关服务规则如由于业务发展需要进行修订的，修订后的条款将在{{ name }}平台公布。您可前往查阅最新版协议条款。
            在本平台修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用{{ name }}贵族服务。您继续使用本服务的，将被视为已接受了修订后的协议。</p>

        <p class="contentBlack">第二条 定义</p>
        <p class="content">2.1 {{ name }}贵族：指{{ name }}平台为您提供的网络增值服务，您在成为{{ name }}贵族后可以依本协议享有一定的特权优惠或参加活动，
            具体以{{ name }}平台相关服务页面公布和实际提供的内容为准。</p>
        <p class="content">2.2 “用户”或“您”：指享受{{ name }}平台提供的{{ name }}贵族服务的个人或单一实体。</p>

        <p class="contentBlack">第三条 成为{{ name }}贵族的程序</p>
        <p class="content">3.1 如您希望使用{{ name }}贵族服务的，需先登录您的{{ name }}帐号，或注册{{ name }}帐号并登录。在成功登录{{ name }}帐号的基础上，
            申请开通{{ name }}贵族服务。如您选用其他第三方帐号登录{{ name }}的，您应保证第三方帐号的稳定性、真实性以及可用性，如因第三方帐号原因
            （如第三方帐号被封号等）致使您无法登录{{ name }}的，您应与第三方帐号的所属公司联系。您在使用{{ name }}贵族服务时登录的{{ name }}帐号是{{ name }}平台确认您身份的唯一依据。</p>
        <p class="content">3.2 您可以在开通服务界面通过{{ name }}平台认可的支付方式完成支付来开通{{ name }}贵族服务。您在开通服务时，应仔细核对帐号名称、
            开通服务类型与时长等具体信息。如因您个人原因造成充错帐号、开通错服务或时长，{{ name }}平台无法退还您误操作损失的费用。</p>
        <p class="content">3.3 您成功开通{{ name }}贵族后可享受多项专属特权和服务，具体以{{ name }}平台相关服务页面公布和实际提供的为准。
            会员资格自{{ name }}贵族服务开通之时起算，具体期限可以登录{{ name }}贵族中心页面进行查看。</p>
        <p class="content">3.4 {{ name }}平台可根据业务发展变化不时调整{{ name }}贵族服务费用标准和贵族服务内容，经调整的会员服务费用标准和贵族服务内容将在会员
            资格支付页上显示，您应及时关注和了解特权内容及政策的变化，并理解和同意{{ name }}平台的调整。{{ name }}平台对特权进行调整之前，您可能已享有或正在享有一定的服务内容或权益，
            您理解和接受{{ name }}平台对该特权进行调整可能会对您已享有或正在享有的权益造成影响，并同意按照调整后的特权内容进行使用，而不要求{{ name }}平台承担任何责任；
            如涉及服务费用标准调整的，您按调整后的服务费用标准支付后方可享有或延续会员资格，已按照原会员服务费用标准购买会员服务的用户，无需补充缴纳金额。</p>

        <p class="contentBlack">第四条 {{ name }}贵族资格的有关规定</p>
        <p class="content">4.1 {{ name }}贵族服务仅限于申请帐号自行使用，且不能在不同的{{ name }}帐号之间转移。</p>
        <p class="content">4.2 {{ name }}贵族类型及权益：贵族权益全新升级，需将APP升级到最新版本，购买的贵族可享受到最新权益；不同类型的贵族对应不同价格、
        不同的会员权益，会员权益相关介绍可在会员中心—九大权益中查看；限时特惠价格属于平台周期性营销活动，恢复原价以平台解释为准。</p>
        <p class="content">4.3 在已开通的{{ name }}贵族有效期内，若您再次购买{{ name }}贵族服务，则新购买的贵族权益将在原来的贵族到期后自动顺延有效期和权益。</p>
        <p class="content">例如：A用户在2022年1月1日10点购买了30天贵族，在有效期内又购买了90天贵族，此时A用户贵族有效期顺延到2022年4月30日10点，90天贵族权益则从1月31日10点起生效。</p>
        <p class="content">4.4 在已开通的{{ name }}贵族有效期内，若您中途主动取消或终止{{ name }}贵族资格的，本平台不负责退还与您剩余服务有效期对应的{{ name }}贵族服务费用。</p>
        <p class="content">4.5 {{ name }}贵族资格取消/终止后，您不能再参加由{{ name }}平台组织的与会员相关的活动并不可再享有由{{ name }}平台提供的各项特权服务及增值服务，
            即不再享有{{ name }}贵族服务。</p>

        <p class="contentBlack">第五条 {{ name }}贵族使用规则</p>
        <p class="content">5.1 您确认：您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织，有能力对您使用{{ name }}贵族服务的一切行为独立承担责任。</p>
        <p class="content">5.2 您应自行负责妥善保管、使用、维护您在{{ name }}平台申请取得的帐号、帐号信息及帐号密码，并对该帐号进行的所有活动和行为负责，禁止赠与、借用、
            租用、转让或售卖该帐号。非{{ name }}平台原因致使您帐号密码泄漏以及因您保管、使用、维护不当造成损失的，{{ name }}平台无须承担与此有关的任何责任。</p>
        <p class="content">5.3 您应当遵守本协议及{{ name }}相关服务规则，如因违反本协议或相关服务规则而致使您会员服务被暂停及/或终止使用的相关损失，由您自行承担。</p>
        <p class="content">5.4 如您实施了下列行为之一，{{ name }}平台有权在不通知您的情况下，终止提供{{ name }}贵族服务，并有权限制、冻结或终止与该服务相关联的{{ name }}帐号使用。
            {{ name }}平台无须给予任何补偿和退费，由此产生的责任由您自行独立承担。因此给{{ name }}平台或第三方造成损失的，您应负责全额赔偿：</p>
        <span class="content">(1) 以营利、经营等非个人使用的目的为自己或他人获得{{ name }}贵族服务；</span>
        <span class="content">(2) 以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非正规方式获得{{ name }}贵族服务；</span>
        <span class="content">(3) 通过不正当手段或以违反诚实信用原则的行为获得{{ name }}贵族服务；</span>
        <span class="content">(4) 通过侵犯{{ name }}或他人合法权益的方式为自己或他人进行{{ name }}贵族注册或使用；</span>
        <span class="content">(5) 将{{ name }}贵族帐号以出租、出借、出售等任何形式提供给第三方使用；</span>
        <span class="content">(6) 将通过{{ name }}贵族服务获得的任何内容用于个人学习、研究或欣赏之外的用途。</span>
        <!-- <span class="content"></span> -->
        <p class="content">5.5 为防止恶意共享帐号或帐号被盗等情况，保护您的帐号安全，您理解并同意，{{ name }}平台可对同一{{ name }}贵族帐号的登录及使用的设备数量
            进行一定限制，同一时间同一帐号仅可在一个设备（不区分移动端或非移动端）上使用。</p>
        <p class="content">5.6 如发生下列任何一种情形，{{ name }}平台有权根据实际情况，在不通知您的情况下中断或终止向您提供的一项或多项或全部服务，由此产生的损失由您承担，
            {{ name }}平台无需给予任何补偿和退费。若因此给{{ name }}平台或第三方造成损失的，您应负责全额赔偿：</p>
        <span class="content">(1) 您提供的个人资料不真实或与注册时信息不一致又未能提供合理证明；</span>
        <span class="content">(2) 经国家行政或司法机关的生效法律文书确认您存在违法、违规或侵权行为，或者{{ name }}平台根据自身的判断，认为您的行为涉嫌违反《{{ name }}服务条款》、
            本协议内容、{{ name }}相关服务规则、涉嫌违反法律法规政策的等规定的</span>
        <span class="content">(3) 您的行为干扰了{{ name }}任何部分或功能的正常运行；</span>
        <span class="content">(4) 您未经{{ name }}平台允许，利用{{ name }}开展需经{{ name }}平台同意的行为，包括但不限于对通过{{ name }}平台进行商业化活动，如附加广告、商业内容或链接等；</span>
        <span class="content">(5) 您的个人信息、发布内容或使用{{ name }}平台服务的行为等违反国家法律法规规定，有悖社会道德伦理、公序良俗、侵犯他人合法权益、政治色彩强烈，
            引起任何争议，或违反本协议、{{ name }}相关服务规则的要求的；</span>
        <span class="content">(6) 您在{{ name }}平台进行任何违法行为的。</span>

        <p class="contentBlack">第六条 责任声明</p>
        <p class="content">6.1 如果您行使本协议规定的权利而购买/接受{{ name }}平台以外的第三方商户提供的商品或服务，如因此发生纠纷的，
            您应向销售/提供该商品或服务的第三方商户主张权利，与{{ name }}平台无关。</p>
        <p class="content">6.2 您须对您自身在参加{{ name }}平台组织的活动或使用由{{ name }}平台提供的各项优惠及增值服务时的实施的一切行为承担全部法律责任。</p>
        <p class="content">6.3 {{ name }}平台不对您因第三方的行为或不作为造成的损失、不可抗力原因造成的损失承担任何责任，包括但不限于支付服务、网络接入服务、
            电信部门的通讯线路故障、通讯技术问题、网络、电脑故障、系统不稳定性、任意第三方的侵权行为等。</p>
        <p class="content">6.4 您理解并同意，在使用{{ name }}贵族服务的过程中，可能会遇到不可抗力等风险因素，使该服务发生中断。如出现上述情况，
            {{ name }}平台承诺将尽快与相关单位配合进行修复，但不承担由此对您造成的任何损失且不退还{{ name }}贵族费用。</p>

        <p class="contentBlack">第七条 其他约定</p>
        <p class="content">7.1 服务中止、中断及终止：{{ name }}平台根据自身商业决策、政府行为、不可抗力等原因可能会选择更改、中止、中断及终止{{ name }}贵族服务。</p>
        <p class="content">7.2 {{ name }}平台对于发送给您所有的通知均可通过站内消息、网页公告、公众号通知、您预留的电子邮件、手机短信以及信件等方式进行，
            该等通知于发送之日视为已送达用户。请您务必对{{ name }}平台发送的通知保持关注。</p>
        <p class="content">7.3 法律与争议解决：本协议适用中华人民共和国的法律，并且排除一切冲突法规定的适用。如出现纠纷，
            您和{{ name }}平台一致同意将纠纷提交中国国际经济贸易仲裁委员会根据其现行有效的仲裁规则进行仲裁。仲裁庭由三名仲裁员组成。仲裁裁决是终局的，
            对双方都有约束力。仲裁费用由败诉一方承担。</p>
        <p class="content">7.4 {{ name }}平台不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响{{ name }}平台在将来行使该权利。</p>
        <p class="content">7.5 如果您对本条款内容有任何疑问，请咨询平台客服进行沟通。</p>

        <p class="contentBlack"></p>
        <p class="content"></p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: '',
            gender: '',
            token: '',
            edition: '',

            name: '',
        }
    },

    created() {
        document.title = '贵族服务协议';
        this.checkName('miqu');
        this.checkURLParams();
    },

    methods: {
        checkURLParams() {
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })
                this.id = p.id;
                this.gender = p.gender;
                this.token = p.token;
                this.checkName(p.edition);
            } catch(e) {}
        },

        checkName(edition) {
            // let str = '';
            // switch(edition) {
            //     case 'miyou':
            //         this.name = '蜜柚';
            //         break;

            //     case 'liaoban':
            //         this.name = '聊伴交友';
            //         break;

            //     case 'liaoban_mimi':
            //         this.name = '聊伴交友';
            //         break;

            //     case 'xunta':
            //         this.name = '寻Ta交友';
            //         break;

            //     case 'banxun':
            //         this.name = "寻缘";
            //         break;

            //     default:
            //         this.name = '本应用';
            //         break;
            // }

            this.name = '觅趣';
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    background-color: #FFF;
}

.content {
    font-size: 12px;
    color: #666;
}
.contentBlack {
    font-size: 12px;
    color: #000;
    font-weight: 600;
}
</style>